import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { ImageIcon, X } from 'lucide-react';

import type { AssetSummary, MediaValue } from '../types';
import FieldShell from './FieldShell';

interface MediaPickerFieldProps {
  title?: string;
  description?: string;
  value?: MediaValue;
  /** Resolves an `asset:<id>` ref to a displayable asset (mocked for now). */
  resolveAssetRef?: (ref: string) => AssetSummary | undefined;
  /** Opens the Cloudinary asset library; selection flows back through onChange upstream. */
  onOpenLibrary: () => void;
  onChange: (value: MediaValue | undefined) => void;
}

export default function MediaPickerField({
  title,
  description,
  value,
  resolveAssetRef,
  onOpenLibrary,
  onChange,
}: MediaPickerFieldProps) {
  const asset = value ? resolveAssetRef?.(value.ref) : undefined;

  return (
    <FieldShell title={title} description={description}>
      {value ? (
        <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-2">
          {asset ? (
            <img
              src={asset.url}
              alt={asset.alt ?? ''}
              className="size-12 shrink-0 rounded-md object-cover"
            />
          ) : (
            <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-zinc-100">
              <ImageIcon className="text-zinc-400" size={20} />
            </div>
          )}
          <div className="min-w-0 grow">
            <div className="truncate text-sm">{asset?.alt ?? 'Image'}</div>
            <button
              type="button"
              onClick={onOpenLibrary}
              className="text-xs text-zinc-500 underline hover:text-zinc-700"
            >
              Replace
            </button>
          </div>
          <button
            type="button"
            aria-label="Remove image"
            onClick={() => onChange(undefined)}
            className="rounded p-1 text-zinc-400 hover:text-zinc-600"
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={onOpenLibrary}
        >
          <ImageIcon size={16} />
          Choose an image
        </Button>
      )}
    </FieldShell>
  );
}
